import { connect } from 'react-redux';

import {
  updateEditPermissions,
  updateRoleRequestBody,
} from '../../redux/actions';

import Form from './Form';

const mapDispatchToProps = {
  updateEditPermissions,
  updateRoleRequestBody,
};

export default connect(null, mapDispatchToProps)(Form);
